// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.empty-data[data-v-6db648de] {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  height: 200px;\r\n  width: 100%;\r\n  color: #666;\r\n  font-size: 16px;\r\n  border: 1px solid #eee;\r\n  border-top: 0;\n}\r\n", ""]);
// Exports
module.exports = exports;
